import {
    FormErrors,
    FormValidation,
    validateDutchPostalCode,
    validateEmailAddress,
    validateForm,
    validateRequiredBoolean,
    validateRequiredString,
    validateUrl,
} from '../../../../entities/@forms/FormValidation/FormValidationService';
import { ParticipateFormData } from '../../../../entities/@forms/ParticipateForm/ParticipateForm';

export type ParticipateFormErrors = FormErrors<ParticipateFormData>;

export const validateParticipateFormData = (formData: ParticipateFormData): FormValidation<ParticipateFormErrors> => {
    const website = formData.website
        ? validateUrl('website', formData.website)
        : undefined;

    const errors: ParticipateFormErrors = {
        companyName: validateRequiredString('companyName', formData.companyName),
        chamberOfCommerce: validateRequiredString('chamberOfCommerce', formData.chamberOfCommerce),
        postalCode: validateDutchPostalCode(formData.postalCode),
        houseNumber: validateRequiredString('houseNumber', formData.houseNumber),
        street: validateRequiredString('street', formData.street),
        city: validateRequiredString('city', formData.city),
        country: validateRequiredString('country', formData.country),
        assortmentDescription: validateRequiredString('assortmentDescription', formData.assortmentDescription),
        signupReason: validateRequiredString('signupReason', formData.signupReason),
        assortmentLocationPreference: validateRequiredString('assortmentLocationPreference', formData.assortmentLocationPreference),
        assortmentSquareMeters: validateRequiredString('assortmentSquareMeters', formData.assortmentSquareMeters),
        participantHistory: validateRequiredString('participantHistory', formData.participantHistory),
        website,
        firstName: validateRequiredString('firstName', formData.firstName),
        lastName: validateRequiredString('lastName', formData.lastName),
        email: validateEmailAddress(formData.email),
        phoneNumber: validateRequiredString('phoneNumber', formData.phoneNumber),
        acceptTermsAndConditions: validateRequiredBoolean('acceptTermsAndConditions', formData.acceptTermsAndConditions),
    };

    return validateForm<ParticipateFormErrors>(errors);
};
